import { useEffect, useRef, useState } from "react";

/**
 * <img> que mostra um esqueleto pulsando enquanto a imagem do servidor carrega.
 * Mesmas props de <img> (className, alt, src...), entao entra no lugar dela sem mexer no
 * layout dos cartoes. Imagens ja em cache nao piscam (`complete` na montagem).
 * O visual do estado "carregando" esta em App.css ([data-carregando]).
 */
export default function ImagemCarregando({ src, alt = "", className, onLoad, onError, ...resto }) {
  const ref = useRef(null);
  const [carregando, setCarregando] = useState(!!src);

  useEffect(() => {
    setCarregando(!!src);
    // Em cache: o load pode ter disparado antes de o React anexar o handler.
    if (src && ref.current?.complete && ref.current.naturalWidth > 0) setCarregando(false);
  }, [src]);

  return (
    <img
      ref={ref}
      src={src}
      alt={alt}
      className={className}
      data-carregando={carregando ? "true" : undefined}
      aria-busy={carregando || undefined}
      onLoad={(e) => { setCarregando(false); if (onLoad) onLoad(e); }}
      onError={(e) => { setCarregando(false); if (onError) onError(e); }}
      {...resto}
    />
  );
}
